import type {
  ICommunitiesApiCommunityRequestUser,
  ICommunitiesApiCommunitySubscriberRelation,
} from '../../redux/api/communities/communities-api.types';
import type { IUsersApiUserInList } from '../../redux/api/users/users-api.types';
import { RelationStatus } from '../../shared/constants';
import type { IUserPermission } from '../../types/interfaces/user';

const emptyUserPermissions: IUserPermission = {
  canSubscribe: false,
  canUnsubscribe: false,
  canRequestSubscription: false,
  canCancelRequestSubscription: false,
  canApproveRequest: false,
  canRejectRequest: false,
  canDropFromSubscribers: false,
  canSeeDetails: false,
  canSeePosts: false,
  canAddPost: false,
};

/**
 * Maps `subscribers` relation rows from GET /communities/:id to list users for {@link UsersList}.
 */
export function mapCommunitySubscriberRelationsToUsers(
  relations: ICommunitiesApiCommunitySubscriberRelation[] | undefined,
): IUsersApiUserInList[] {
  if (!relations?.length) {
    return [];
  }

  return relations
    .filter((r) => r.user?.id)
    .map((r) => {
      const u = r.user!;
      const withPerms = u as Partial<IUsersApiUserInList>;

      return {
        id: u.id,
        firstname: u.firstname ?? '',
        lastname: u.lastname ?? '',
        avatar: u.avatar ?? null,
        permissions: withPerms.permissions ?? emptyUserPermissions,
      };
    });
}

/** Badge: pending = requested (or legacy rows without `status`); excludes rejected. */
export function countPendingCommunityRequests(
  requests: ICommunitiesApiCommunityRequestUser[] | undefined,
): number {
  if (!requests?.length) {
    return 0;
  }

  return requests.filter((r) => r.status !== RelationStatus.rejected).length;
}
